import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Button, Grid, TextField, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import { getPermissionKey } from "..";
import { checkApiStatus, checkPermission, } from '../../utils_v2';
import { globalGetService, globalPutService } from '../../../globalServices';
import { PageLoader, STableLoader } from '../../shared_elements';
import { assetTypeValues, } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';
const TAAircraftAttributes = ({ params, assetInfoData }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [aircraftAttributes, setAircraftAttributes] = useState({});
    useEffect(() => {
        getAircraftAttributes('skeletonLoader');
    }, []);
    const getAircraftAttributes = (loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/aircraft_attributes/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraftAttributes(response.data.data);
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            })
    }
    const onFieldChange = (key, value) => {
        setAircraftAttributes({ ...aircraftAttributes, [key]: value });
    }
    const onEditAircraftAttributes = () => {
        setLoading(true);
        let payload = Object.assign({}, aircraftAttributes)
        globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/aircraft_attributes/`, payload)
            .then(response => {
                if (checkApiStatus(response)) {
                    getAircraftAttributes('pageloader')
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    trackActivity('Console Management', {data:JSON.stringify(payload), page_title: 'Aircraft Attribute(Titan Aviation)', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Aircraft Attributes Details data from Edit Aircraft Attributes Details form' });
                    setEdit(false);
                }
                setLoading(false);
            })
    }
    return (
        <div style={{ position: 'relative' }}>
            <div className="console-forms-fields" style={{ height: `${window.innerHeight - (isEdit ? 260 : 215)}px`, padding: '10px', overflow: 'auto' }}>
                <p style={{ textAlign: 'right', height: '20px' }}>
                    {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
                        <span style={{ cursor: 'pointer' }}>
                            <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
                        </span> : null
                    }
                </p>
                {skeletonLoader ? < STableLoader count={3}  size={7}/> : <>
                    <Grid container spacing={1}>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='cockpit_display'
                                label='Cockpit Display Type'
                                value={aircraftAttributes?.cockpit_display || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 255 }}
                                onChange={(e) => onFieldChange('cockpit_display', e.target.value.trimStart())}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='unit_of_measurement '
                                label='Unit of Measurement '
                                value={aircraftAttributes?.unit_of_measurement || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 255 }}
                                onChange={(e) => onFieldChange('unit_of_measurement', e.target.value.trimStart())}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            {(() => {
                                let options = ['Degrees C', 'Fahrenheit F'];
                                return (
                                    <Autocomplete
                                        disabled={!isEdit}
                                        options={options}
                                        getOptionLabel={option => option}
                                        name="cockpit_temperature"
                                        value={aircraftAttributes?.cockpit_temperature || ''}
                                        onChange={(e, value) => { onFieldChange('cockpit_temperature', value); }}
                                        renderInput={params => <TextField {...params} label="Cockpit Temperature" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                )
                            })()}
                        </Grid>
                        <Grid item md={4}>
                            {(() => {
                                let options = ['Yes', 'No'];
                                return (
                                    <Autocomplete
                                        disabled={!isEdit}
                                        options={options}
                                        getOptionLabel={option => option}
                                        name="reinforced_cockpit_door"
                                        value={aircraftAttributes?.reinforced_cockpit_door || ''}
                                        onChange={(e, value) => { onFieldChange('reinforced_cockpit_door', value); }}
                                        renderInput={params => <TextField {...params} label="Reinforced Cockpit Door " margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                )
                            })()}
                        </Grid>
                        <Grid item md={4}>
                            {(() => {
                                let options = ['Standard', 'Winglets', 'Sharklets'];
                                return (
                                    <Autocomplete
                                        disabled={!isEdit}
                                        options={options}
                                        getOptionLabel={option => option}
                                        name="winglets_sharklets"
                                        value={aircraftAttributes?.winglets_sharklets || ''}
                                        onChange={(e, value) => { onFieldChange('winglets_sharklets', value); }}
                                        renderInput={params => <TextField {...params} label="Winglets/Sharklets" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                )
                            })()}
                        </Grid>
                        {assetInfoData?.aircraft_type?.name?.startsWith('B777') ?
                            <Grid item md={4}>
                                {(() => {
                                    let options = ['Large', 'Small'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="aft_door"
                                            value={aircraftAttributes?.aft_door || ''}
                                            onChange={(e, value) => { onFieldChange('aft_door', value); }}
                                            renderInput={params => <TextField {...params} label="AFT Lower Deck Cargo Door" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />} />
                                    )
                                })()}
                            </Grid> : null}
                        {[2, 3].includes(assetInfoData?.aircraft_operation?.value) ?
                            <Grid item md={4}>
                                {(() => {
                                    let options = ['Powered', 'Non-Powered'];
                                    return (
                                        <Autocomplete
                                            disabled={!isEdit}
                                            options={options}
                                            getOptionLabel={option => option}
                                            name="cargo_loading_system"
                                            value={aircraftAttributes?.cargo_loading_system || ''}
                                            onChange={(e, value) => { onFieldChange('cargo_loading_system', value); }}
                                            renderInput={params => <TextField {...params} label={"Cargo Loading System-Main Deck"} margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    )
                                })()}
                            </Grid> : null}
                        <Grid item md={4}>
                            {(() => {
                                let options = ['Powered', 'Non-Powered'];
                                return (
                                    <Autocomplete
                                        disabled={!isEdit}
                                        options={options}
                                        getOptionLabel={option => option}
                                        name="cargo_loading_system_lower"
                                        value={aircraftAttributes?.cargo_loading_system_lower || ''}
                                        onChange={(e, value) => { onFieldChange('cargo_loading_system_lower', value); }}
                                        renderInput={params => <TextField {...params} label="Cargo Loading System-Lower Deck" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                )
                            })()}
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='bulk_cargo_door'
                                label='Bulk Cargo Door'
                                value={aircraftAttributes?.bulk_cargo_door || ''}
                                fullWidth
                                inputProps={{ maxLength: 255 }}
                                margin="normal"
                                onChange={(e) => onFieldChange('bulk_cargo_door', e.target.value.trimStart())}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField
                                disabled={!isEdit}
                                name='quick_access_recorder'
                                label='Quick Access Recorder'
                                value={aircraftAttributes?.quick_access_recorder || ''}
                                fullWidth
                                margin="normal"
                                inputProps={{ maxLength: 255 }}
                                onChange={(e) => onFieldChange('quick_access_recorder', e.target.value.trimStart())}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>

                    </Grid>
                </>}
            </div>
            {isEdit ?
                <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7' }}>
                    <ul className="list-inline">
                        <li className="list-inline-item">
                            <Button onClick={() => { setEdit(false); getAircraftAttributes() }} color="primary" size='small' variant="outlined">Cancel</Button>
                        </li>
                        <li className="list-inline-item">
                            <Button onClick={onEditAircraftAttributes} color="primary" size='small' variant="contained">SAVE</Button>
                        </li>
                    </ul>
                </Paper> : null
            }
            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(TAAircraftAttributes);